import React from 'react';

function getLabelStyles(size) {
    switch (size) {
        case 'xsmall':
            return 'text-xs';
        case 'small':
            return 'relative text-sm cursor-pointer';
        case 'large':
            return 'text-xl leading-tight col-span-full';
        case 'xlarge':
            return 'text-2xl sm:text-3xl leading-tight col-span-full';
        default:
            return 'text-base leading-tight col-span-full';
    }
}
const FieldLabel = ({ className = '', label, labelVisible, id, size = 'default', }) => (React.createElement("label", { className: [
        'prose',
        labelVisible ? 'select-none' : 'sr-only',
        getLabelStyles(size),
        className,
    ].join(' '), htmlFor: id, suppressHydrationWarning: true }, label));

export { FieldLabel };
//# sourceMappingURL=FieldLabel.js.map
